export const TrackingInfo = {
  dataCategory: "My Account Area Drawer",
  dataAction: "click",
  dataLabel: ""
};
